// `/dancers/new` — new-record mode in the profile pane.

import { useQueryClient } from '@tanstack/react-query';
import {
	createFileRoute,
	useNavigate,
	useRouteContext,
} from '@tanstack/react-router';
import type { TalentSummary } from '~/bounded-contexts/roster/domain/types';
import { AddDancerForm } from '~/bounded-contexts/roster/ui/add-dancer/add-dancer-form';
import { rosterQueryKey } from '~/bounded-contexts/roster/ui/dancers-page/query-key';

function NewDancerRouteComponent() {
	const ctx = useRouteContext({ from: '/_authenticated' });
	const club_id = ctx?.scope?.club?.id ?? '';
	const navigate = useNavigate();
	const queryClient = useQueryClient();
	const back_to_roster = () => void navigate({ to: '/dancers' });

	return (
		<AddDancerForm
			on_saved={(talent: TalentSummary | null) => {
				if (!talent) return back_to_roster();
				const working = rosterQueryKey(club_id, false);
				// Seeded before the navigation so her profile has her on first
				// render: the refetch below lands too late to stop a not-found.
				queryClient.setQueryData<readonly TalentSummary[]>(
					working,
					(cached) => [...(cached ?? []), talent],
				);
				void queryClient.invalidateQueries({ queryKey: working });
				void navigate({
					to: '/dancers/$talentId',
					params: { talentId: talent.id },
				});
			}}
			on_cancel={back_to_roster}
		/>
	);
}

export const Route = createFileRoute('/_authenticated/dancers/new')({
	component: NewDancerRouteComponent,
});
